import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/ui/button'
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@/shared/ui/empty'

/**
 * A url this application does not have.
 *
 * Renders bare, because a url that matched nothing has no workspace to draw a
 * sidebar for.
 */
export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <Empty className="min-h-dvh">
      <EmptyHeader>
        <EmptyTitle>{t('notFound.title')}</EmptyTitle>
        <EmptyDescription>{t('notFound.description')}</EmptyDescription>
      </EmptyHeader>
      <Button asChild variant="outline">
        <Link to="/dashboard">{t('notFound.home')}</Link>
      </Button>
    </Empty>
  )
}
